"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalRHub = void 0;
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
const signalr_1 = require("@microsoft/signalr");
class SignalRHub {
    constructor(id, connection, isDebug, authorize) {
        this.connection = connection;
        this.isDebug = isDebug;
        this.id = id;
        this.authorization = authorize;
    }
    isOnline() {
        return Boolean(this.connection && this.connection.state === signalr_1.HubConnectionState.Connected);
    }
    authorizeMethod(methodName) {
        const methodNameLowercase = methodName.toLowerCase();
        const key = Object.keys(this.authorization).find((x) => x.toLowerCase() === methodNameLowercase);
        const authorize = key ? this.authorization[key] : null;
        if (authorize && typeof authorize === 'function' && authorize()) {
            return;
        }
        if (authorize === true) {
            return;
        }
        throw new Error(`[SignalR] Forbidden operation: ${this.id} not authorized to access ${methodName}`);
    }
    call(methodName, argument) {
        return __awaiter(this, void 0, void 0, function* () {
            this.authorizeMethod(methodName);
            if (this.connection && this.isOnline()) {
                if (this.isDebug) {
                    if (argument) {
                        console.log(`[SignalR] ${this.id} is calling method ${methodName} with argument\n${JSON.stringify(argument)}`);
                    }
                    else {
                        console.log(`[SignalR] ${this.id} is calling method ${methodName}`);
                    }
                }
                if (argument) {
                    yield this.connection.send(methodName, argument);
                }
                else {
                    yield this.connection.send(methodName);
                }
            }
            return Promise.resolve();
        });
    }
    invoke(methodName, argument) {
        return __awaiter(this, void 0, void 0, function* () {
            this.authorizeMethod(methodName);
            if (this.connection && this.isOnline()) {
                if (this.isDebug) {
                    if (argument) {
                        console.log(`[SignalR] ${this.id} is invoking method ${methodName} with argument:\n${JSON.stringify(argument)}`);
                    }
                    else {
                        console.log(`[SignalR] ${this.id} is invoking method ${methodName}`);
                    }
                }
                let result = null;
                if (argument) {
                    result = yield this.connection.invoke(methodName, argument);
                }
                else {
                    result = yield this.connection.invoke(methodName);
                }
                if (this.isDebug) {
                    console.log(`[SignalR] ${this.id} invoked method ${methodName} and returned:\n${JSON.stringify(result)}`);
                }
                return result;
            }
            return Promise.resolve(null);
        });
    }
    on(methodName, method) {
        this.authorizeMethod(methodName);
        const handler = (argument) => {
            if (this.isDebug) {
                console.log(`[SignalR] ${this.id} received ${methodName} with argument: \n${JSON.stringify(argument)}`);
            }
            method(argument);
        };
        if (this.connection) {
            this.connection.on(methodName, handler);
            if (this.isDebug) {
                console.log(`[SignalR] ${this.id} subscribed to ${methodName}`);
            }
            return () => this.off(methodName, handler);
        }
        return null;
    }
    off(methodName, method) {
        this.authorizeMethod(methodName);
        if (this.connection) {
            this.connection.off(methodName, method);
            if (this.isDebug) {
                console.log(`[SignalR] ${this.id} unsubscribed from ${methodName}`);
            }
        }
    }
}
exports.SignalRHub = SignalRHub;
